/**
 * File that can be loaded in each page as a mixin, handles generic stuff for status functions
 */
export const statusMixin = {
    data() {
        return {
            /**
             * These statuses are used when a user can decide a new status the text is the 
             * part the user can see. The value will go into the isDisabled field.
             * The user can not choose status new, that is based on if the effective version
             * is status accepted.
             */
            statuses: [
                {value: false, text: "Actief"},
                {value: true, text: "Inactief"}
            ],
            statusesIncludingNew: [
                "Actief",
                "Inactief",
                "Nieuw"
            ]
        }
    },
    methods: {
        isActive(status){
            let isActive = false;
            //Converting to lowercase to be case insensitive
            status.toLowerCase();
            switch (status){
                case "geaccepteerd":
                    isActive = true;
                    break;
                case "accepted":
                    isActive = true;
                    break;
                case "default":
                    //Do nothing if not a case then status is not active
            }

            return isActive;
        },
        /**
         * The following cases have been defined regarding object statuses in the frontend:
         * 1) An object is seen by the user as 'Nieuw' if status is 'requested'.
         * 2) Otherwise if the status is rejected, the object is seen by the user as 'Inactief'.
         * 3) In all other cases the status is based on the isDisabled flag.
         */
        getStatusFromItemWithNew(item) {
            let status;

            switch (item.status) {
                case "requested":
                    status = "Nieuw";
                    break;
                case "rejected":
                    status = "Inactief";
                    break;
                default:
                    status = this.getStatusFromIsDisabled(item.isDisabled);
                    break;
            }

            return status;
        },
        /**
         * When judging an object we only know the value of isDisabled so we use this function.
         * On judgment we need to know if the object will be active or inactive after judgement
         * therefore we always show the status and not Nieuw.
         *  
         * Using === false check on purpose so the function only returns actief 
         * if item.isDisabled exists and is false. If there is no isDisabled item is
         * inactief.
         */
        getStatusFromIsDisabled(isDisabled) {
            return (isDisabled === false) ? "Actief" : "Inactief";
        },
        //An object is nieuw if the effective version does not have the 'accepted' status
        isNew(status){
            return status !== "accepted";
        },
        /**
         * In the mapped object, make sure that couplingDisabled exists and is made like in lidFunctionaliteitAutorisaties
         * or lidGebruikersgroepFunctionaliteiten
         * 
         * @param {*} currentObject 
         * @param {*} newObject 
         * @returns true when a coupling is created (in the eyes of the user) (sometimes PUT sometimes POST)
         */
        isNewCoupling(currentObject, newObject){
            //couplingDisabled and newObject.isDisabled are the isDisabled in the database. 
            //The only time when isDisabled of the request and isDisabled of the original value are both the same is
            //when a coupling is actually created (POST REQUEST, no put request).
            if (currentObject.couplingDisabled === false && newObject.isDisabled === false) {
                return true;
            }

            //coupling can only go from disabled -> true to disabled -> false or vice versa
            //So when the coupling is disabled, it must have a change to become active
            if (currentObject.couplingDisabled) {
                return true;
            }

            return false;
        },
        //Function to check if the object has status requested.
        hasRequest(item){
            let hasRequest = false;

            if (item.status && item.status.toLowerCase() === "requested") {
                hasRequest = true;
            }

            return hasRequest;
        },
        isArray(item) {
            return Array.isArray(item)
        },
        getStatusColor(status) {
            switch (status.toLowerCase()) {
                case "nieuw":
                    return "orange";
                case "actief":
                    return "green";
                case "inactief":
                    return "purple"
                default:
                    return "grey";
            }
        },
        //Translates the status and can be used both ways
        translateStatus(status) {
            switch (status.toLowerCase()) {
                //EN -> NL
                case "requested":
                    return "Aangevraagd";
                case "accepted":
                    return "Geaccepteerd";
                case "rejected":
                    return "Geweigerd";
                //NL -> EN
                case "aangevraagd":
                    return "requested";
                case "geaccepteerd":
                    return "accepted";
                case "geweigerd":
                    return "rejected";
                //Not found do not translate
                default:
                    return status;
            }
        }
    }
}